exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsible {\n  border: none;\n  margin: 0.5rem 0 1rem 0;\n}\n\n.collapsible-header {\n  color: #607d8b\n}\n\n.collapsible-body {\n  border: none;\n  padding-bottom: 0.5rem;\n}\n\n\n.collapsible-body {\n  border: none;\n  padding: 10px 10px 0 10px;\n}\n\n[type=\"checkbox\"].filled-in:checked + label:after {\n  top: 0;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #27476E;\n  color: #27476E;\n  z-index: 0;\n}\n\n.material-icons.mrc-red { color: #e57373; }\n.material-icons.mrc-blue { color: #27476E; }\n\n.material-icons.md-18 { font-size: 18px; }\n.material-icons.md-24 { font-size: 24px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/accountadmin/accountadmin.component.css
// module id = ../../../../../src/app/accountadmin/accountadmin.component.css
// module chunks = main